import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthSection } from '../components';
import { AuthTwoFactorForm, AuthTwoFactorSetup } from '../two-factor';
import { AuthSignInForm } from './sign-in-form';
import { AuthSignInOptionsForm } from './sign-in-options-form';
import { useCompanySignInSubmit, useSignInSettings } from '../hooks';

interface SignInBodyProps {
    onSuccess?: () => void;
}

export const SignInBody: React.FC<SignInBodyProps> = ({ onSuccess }) => {
    const { isDynamicConfiguration, isSsoEnabled, slug, title } = useSignInSettings();
    const {
        signInDynamicForm: _signInDynamicForm,
        getSignInOptions,
        signInOptions,
        resetSignInOptions,

        signInSubmit,
        twoFactorType,

        isSetupTwoFactorStep,
        config2Fa,
        is2FaLoading,

        isVerifyTwoFactorStep,
        verify2FaData,
        isVerifying,
        verify,
    } = useCompanySignInSubmit();

    const { t } = useTranslation();

    const twoFactorForm = <AuthTwoFactorForm request={verify} twoFactorType={twoFactorType} onSuccess={onSuccess} />;
    const signInForm = (
        <AuthSignInForm
            email={_signInDynamicForm?.email}
            resetSignInOptions={resetSignInOptions}
            isSsoEnabled={signInOptions?.hasSsoMethod || isSsoEnabled}
            hasSsoOnly={signInOptions?.hasSsoOnly}
            slug={slug}
            request={signInSubmit}
            onSuccess={onSuccess}
        />
    );
    const signInOptionsForm = <AuthSignInOptionsForm email={_signInDynamicForm?.email} request={getSignInOptions} />;
    const signInHandler = isDynamicConfiguration && !signInOptions ? signInOptionsForm : signInForm;

    return isSetupTwoFactorStep ? (
        <AuthTwoFactorSetup
            isLoading={is2FaLoading || isVerifying}
            config={config2Fa}
            recoveryCodes={verify2FaData?.backup_codes}
            onSuccess={onSuccess}
        >
            <AuthTwoFactorForm request={verify} />
        </AuthTwoFactorSetup>
    ) : (
        <AuthSection
            title={t('titles.signIn', 'Sign in to {{company}}', {
                company: title,
            })}
        >
            {isVerifyTwoFactorStep ? twoFactorForm : signInHandler}
        </AuthSection>
    );
};
